import { render, staticRenderFns } from "./eventEditTable.vue?vue&type=template&id=068dc57c&scoped=true&"
import script from "./eventEditTable.vue?vue&type=script&lang=ts&"
export * from "./eventEditTable.vue?vue&type=script&lang=ts&"
import style0 from "./eventEditTable.vue?vue&type=style&index=0&id=068dc57c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068dc57c",
  null
  
)

export default component.exports